import React from 'react';
import { CheckCircle, AlertCircle, Lightbulb } from 'lucide-react';

const AITierSummary = ({ tier, analysis, colleges }) => {
  if (!analysis) return null;

  // Tier-specific colors
  const tierColors = {
    reach: {
      bg: 'bg-coral-50',
      border: 'border-coral-600',
      text: 'text-coral-900',
      confidenceText: 'text-coral-600'
    },
    target: {
      bg: 'bg-teal-50',
      border: 'border-teal-600',
      text: 'text-teal-900',
      confidenceText: 'text-teal-600'
    },
    safety: {
      bg: 'bg-gold-50',
      border: 'border-gold-600',
      text: 'text-gold-900',
      confidenceText: 'text-gold-600'
    }
  };

  const colors = tierColors[tier] || tierColors.target;

  return (
    <div className="bg-white border-2 border-slate-900 rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-slate-900">AI Tier Analysis</h3>
        <div className={`${colors.bg} border-2 ${colors.border} rounded-lg px-3 py-1`}>
          <span className={`text-xs font-semibold ${colors.text}`}>Confidence Score: </span>
          <span className={`text-lg font-bold ${colors.confidenceText}`}>
            {analysis.confidence || 8}/10
          </span>
        </div>
      </div>

      <div className="space-y-4">
        {/* Strengths */}
        {analysis.strengths && analysis.strengths.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <CheckCircle className="w-5 h-5 text-teal-600" />
              <h4 className="font-semibold text-slate-900">Strengths</h4>
            </div>
            <ul className="space-y-1 text-sm text-slate-700 ml-7">
              {analysis.strengths.map((strength, idx) => (
                <li key={idx}>• {strength}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Gaps & Considerations */}
        {analysis.gaps && analysis.gaps.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <AlertCircle className="w-5 h-5 text-gold-600" />
              <h4 className="font-semibold text-slate-900">Gaps & Considerations</h4>
            </div>
            <ul className="space-y-1 text-sm text-slate-700 ml-7">
              {analysis.gaps.map((gap, idx) => (
                <li key={idx}>• {gap}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Recommendations */}
        {analysis.recommendations && analysis.recommendations.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Lightbulb className="w-5 h-5 text-azure-600" />
              <h4 className="font-semibold text-slate-900">Recommendations</h4>
            </div>
            <ul className="space-y-1 text-sm text-slate-700 ml-7">
              {analysis.recommendations.map((rec, idx) => (
                <li key={idx}>• {rec}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Overall Assessment */}
        {analysis.assessment && (
          <div className="pt-3 border-t border-slate-200">
            <p className="text-sm text-slate-800 italic">
              {analysis.assessment}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AITierSummary;
